import React from 'react';
import { Building } from 'lucide-react';

interface WelcomeMessageProps {
  locationName: string;
  setSelectedRack: (rackId: number) => void;
  setShowFloorDesigner: (show: boolean) => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({
  locationName,
  setSelectedRack,
  setShowFloorDesigner
}) => {
  return (
    <div className="bg-gray-800 rounded-lg p-8 text-center">
      <Building className="w-16 h-16 mx-auto text-gray-500 mb-4" />
      <h3 className="text-xl font-semibold mb-2">Welcome to {locationName}!</h3>
      <p className="text-gray-400 mb-4">
        This location is ready for development. Start by purchasing your first rack or designing a floor.
      </p>
      <div className="flex gap-4 justify-center">
        <button 
          onClick={() => { setSelectedRack(0); /* Using numeric ID to match updated type */ }}
          className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold text-white transition-colors"
        >
          Buy First Rack
        </button>
        <button 
          onClick={() => setShowFloorDesigner(true)} 
          className="px-6 py-3 bg-green-600 hover:bg-green-700 rounded-lg font-semibold text-white transition-colors"
          title="Design and build out a new floor (Phase 4)"
        >
          Design New Floor
        </button>
      </div>
    </div>
  );
};

export default WelcomeMessage;
